import { dayjs } from "@/core/utils/date";
import { ITextMessage } from "@/text-messages/text-messages";

/**
 * Determines whether to show the time for a message based on the next message.
 * @param message - The current message object
 * @param nextMessage - The next message object (or undefined if last)
 * @returns Whether to show the time for the current message
 */
export const shouldShowMessageTime = (
  message: ITextMessage,
  nextMessage?: ITextMessage,
): boolean => {
  if (!nextMessage) return true;
  const sameDirection = message.direction === nextMessage.direction;
  const thisTime = dayjs(message.created_at);
  const nextTime = dayjs(nextMessage.created_at);
  const diffMinutes = Math.abs(nextTime.diff(thisTime, "minute"));
  if (sameDirection && diffMinutes <= 10) {
    return false;
  }
  return true;
};
